"use client";

import { useRouter } from "next/navigation";
import { useState, type FormEvent } from "react";

export function LoginForm() {
	const router = useRouter();
	const [error, set_error] = useState("");

	async function on_submit(event: FormEvent<HTMLFormElement>) {
		event.preventDefault();
		const form = new FormData(event.currentTarget);
		const response = await fetch("/api/v1/auth/login", {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				email: form.get("email"),
				password: form.get("password"),
			}),
		});
		const json = await response.json();
		if (!response.ok) {
			set_error(json?.error?.message ?? "Anmeldung fehlgeschlagen.");
			return;
		}

		router.push("/app");
		router.refresh();
	}

	return (
		<form className="stack" onSubmit={on_submit}>
			{error ? <div className="flash-error">{error}</div> : null}
			<label>E-Mail<input name="email" type="email" required /></label>
			<label>Passwort<input name="password" type="password" required /></label>
			<button type="submit">Anmelden</button>
		</form>
	);
}
